export default "__VITE_ASSET__CEA56Cn2__"